import axios from "axios";
import log from "./log";

//Set this up on init if u want some actions done on 401/403 responses
let logoutCallback = null;
const setLogoutCallback = i_logoutCallback => logoutCallback = i_logoutCallback;

axios.interceptors.response.use(null, error => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status <= 500;

  if (!expectedError) {
    log.error('Axios response error',error);
    throw new Error(error.response);
  }
  //
  // TODO - NEED TO REVISIT THIS PLACE SOON FOR BETTER ERROR HANDLING 
  //
  if(error && error.response && error.response.status){//not authorized - login out
    if(error.response.status === 401 || error.response.status === 403 || error.response.status === 500){
        logoutCallback && logoutCallback();
    }
  }

  return Promise.reject(error);
});

function setJwt(jwt) {
  axios.defaults.headers.common["x-auth-token"] = jwt;
}

function setAppApiBaseUrl(app_url) {
  axios.defaults.baseURL = app_url;
  axios.defaults.timeout = 20000;
  // log.debug("APP api url", axios.defaults.baseURL);
}

 const http = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete,
  setAppApiBaseUrl,
  setLogoutCallback,
  setJwt
};

export default http;

/**
 * Wrapps a response from a TalisAPI call and check it is not an internal PHP error, which does not reflect as 500
 * @param {*} response 
 * @param {*} callback 
 */
export function talisWrapper(response,callback){
  log.debug("Response from TalisAPI:",response);
  //check for 204 -> no content
  if(response.status === 204){
    return callback(response);
  }

  if(!response.data || !response.data.type || response.data.type !== "response"){
    console.error('TalisWrapper API error',response);
    throw new Error(response);    
  }

  return callback(response);
}

/**
 * Wraps an API call with all error handling functionality
 * 
 * @param {*} myPromise 
 * @param {*} successCallback 
 * @param {*} errorCallback 
 */
export function responsePromiseChainHandler(myPromise,successCallback,errorCallback){
  myPromise.then(response=>talisWrapper(response,successCallback)).catch(errorCallback);
}
